(function (w, $, _) {
    'use strict';

    function checkout(paymentId, $container, controller, settings) {
        var _paymentId = paymentId;
        var _$container = $container, _ui;
        var _controller = controller;
        var _countriesRequireState = w.umwAssets['paypal'][0].countriesRequreState;
        var _template = w.umwAssets['paypal'][0].template;
        var _supportedCountries = w.umwAssets['paypal'][0].supportedCountries;
        var _labels = w.umwAssets['paypal'][0].labels;
        var _settings = $.extend({
            isDeliveryPostalCodeReadonly: false, // true if delivery postal code input is handled by the control. In this case checkout shell not allow user modify it
        }, settings);
        var _state = {
            sendOrderInitialized: false, // true when user initialized sending order (pressed send button)
            updatingOrder: false, // true when order updating (in process)
        };

        renderUi();
        setupUi();

        function renderUi() {
            var templateData = {
                supportedCountries: _supportedCountries,
                labels: _labels
            };
            var paypalOrderForm = _.template(_template, templateData);

            _$container.empty();
            _$container.append(paypalOrderForm);
        }
        function setupUi() {
            _ui = {};
            _ui.$txbEmail = _$container.find('.js-paypal-delivery-email');
            _ui.$txbDeliveryFirstName = _$container.find('.js-paypal-delivery-first-name');
            _ui.$txbDeliveryLastName = _$container.find('.js-paypal-delivery-last-name');
            _ui.$txbDeliveryAddress1 = _$container.find('.js-paypal-delivery-address1');
            _ui.$txbDeliveryAddress2 = _$container.find('.js-paypal-delivery-address2');
            _ui.$txbDeliveryPostalCode = _$container.find('.js-paypal-delivery-post-code');
            _ui.$txbDeliveryPostalArea = _$container.find('.js-paypal-delivery-post-area');
            _ui.$drpCountry = _$container.find('.js-paypal-delivery-country');
            _ui.$txbDeliveryState = _$container.find('.js-paypal-delivery-state');
            _ui.$txbDeliveryPhone = _$container.find('.js-paypal-delivery-phone');
            _ui.$lbTotalPrice = _$container.find('.js-paypal-total-price');
            _ui.$lbPriceExlVatMsg = _$container.find('.js-paypal-price-excl-vat-msg');
            _ui.$btnSendOrder = _$container.find('.js-paypal-send-order');

            var $nameInputs = _ui.$txbDeliveryFirstName.add(_ui.$txbDeliveryLastName);
            var $addressInputs = _ui.$txbEmail.add(_ui.$txbDeliveryAddress1).add(_ui.$txbDeliveryAddress2).add(_ui.$txbDeliveryPostalCode).add(_ui.$txbDeliveryPostalArea).add(_ui.$drpCountry).add(_ui.$txbDeliveryPhone).add(_ui.$txbDeliveryState);
            var $shippingInputs = $addressInputs.add($nameInputs);

            _ui.$txbDeliveryPostalCode.prop('disabled', _settings.isDeliveryPostalCodeReadonly);

            _ui.$btnSendOrder.click(function (e) {
                e.preventDefault();

                _state.sendOrderInitialized = true;
                if (!_state.updatingOrder) {
                    sendOrder();
                }
            });

            addPayPalShippingDetailsChangeListeners();

            function addPayPalShippingDetailsChangeListeners() {
                $shippingInputs.on('change', function () {
                    $(this).data('userChanged', true);
                    _state.updatingOrder = true;
                    _controller.updateOrder();
                });

                $shippingInputs.on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        var $inputs = _$container.find(':input:visible:enabled');
                        var idx = $inputs.index(this);

                        if ($inputs.length) {
                            if (idx === $inputs.length - 1) {
                                $inputs[0].select();
                            } else {
                                var nextInput = $inputs[idx + 1];
                                nextInput.focus();
                                nextInput.select();
                            }
                            return false;
                        }
                    }
                    return true;
                });

                _ui.$drpCountry.on('change', function () {
                    setStateRequired(this.value);
                });
            }
        }
        function validateForm(successCallback) {
            var validator = _$container.validate({ ignore: ':hidden' });
            validator.resetForm();
            var isFormValid = validator.form();
            if (isFormValid) {
                if (typeof (successCallback) === 'function') {
                    successCallback.apply(this, []);
                }
            }
        };

        function updateCheckoutUi(checkoutOrderModel) {
            updateDeliveryAddressUi(checkoutOrderModel.orderDetails);
            updateTotalPriceUi(checkoutOrderModel.orderDetails);
        }
        function updateDeliveryAddressUi(deliveryAddress) {
            _ui.$txbEmail.val(deliveryAddress.deliveryEmail);
            _ui.$txbDeliveryFirstName.val(deliveryAddress.deliveryFirstName);
            _ui.$txbDeliveryLastName.val(deliveryAddress.deliveryLastName);
            _ui.$txbDeliveryAddress1.val(deliveryAddress.deliveryAddress1);
            _ui.$txbDeliveryAddress2.val(deliveryAddress.deliveryAddress2);
            _ui.$txbDeliveryPostalCode.val(deliveryAddress.deliveryPostalCode);
            if (deliveryAddress.deliveryPostalArea) {
                _ui.$txbDeliveryPostalArea.val(deliveryAddress.deliveryPostalArea);
            }
            if (deliveryAddress.deliveryCountryCode) {
                _ui.$drpCountry.val(deliveryAddress.deliveryCountryCode);
            }
            _ui.$txbDeliveryPhone.val(deliveryAddress.deliveryPhone);
            _ui.$txbDeliveryState.val(deliveryAddress.state);

            setStateRequired(deliveryAddress.deliveryCountryCode);
        }
        function updateTotalPriceUi(checkoutOrder) {
            _ui.$lbTotalPrice.text(checkoutOrder.sellPriceTotal);

            if (typeof checkoutOrder.includeVAT === 'boolean') {
                _ui.$lbPriceExlVatMsg.toggle(!checkoutOrder.includeVAT);
            }
        }
        function setStateRequired(countryCode) {
            var isStateRequired = _.contains(_countriesRequireState, countryCode);
            $('.PayPalDeliveryStateRow').toggle(isStateRequired);
        }
        function sendOrder() {
            _state.sendOrderInitialized = false;

            validateForm(function() {
                _controller.confirmOrder(true);
            });
        }
        function confirmOrder(paymentProviderInternalData) {
            if (!paymentProviderInternalData) {
                w.PubSub.publish('notification', { type: 'error', text: 'Redirect url was not found' });
                console.error('[PayPal]: Redirect url was not found');
            } else {
                w.location.href = paymentProviderInternalData;
            }
        }

        return {
            getPaymentId: function () { return _paymentId; },
            getSpecifics: function () {
                return {
                    name: 'PayPal',
                    canDisableDeliveryPostalCode: true
                };
            },
            getOrderFormValues: function () {
                var orderForm = {};

                if (!_ui) {
                    return orderForm;
                }

                var deliveryAddress = {};
                deliveryAddress.email = getValue(_ui.$txbEmail);
                deliveryAddress.firstName = getValue(_ui.$txbDeliveryFirstName);
                deliveryAddress.lastName = getValue(_ui.$txbDeliveryLastName);
                deliveryAddress.phone = getValue(_ui.$txbDeliveryPhone);
                deliveryAddress.address1 = getValue(_ui.$txbDeliveryAddress1);
                deliveryAddress.address2 = getValue(_ui.$txbDeliveryAddress2);

                if (!_ui.$txbDeliveryPostalCode.is(':disabled')) {
                    deliveryAddress.postalCode = getValue(_ui.$txbDeliveryPostalCode);
                }
                deliveryAddress.postalArea = getValue(_ui.$txbDeliveryPostalArea);
                if (!_ui.$drpCountry.is(':disabled')) {
                    deliveryAddress.countryCode = _ui.$drpCountry.val();
                }

                if (_ui.$txbDeliveryState.is(':visible')) {
                    deliveryAddress.stateCode = _ui.$txbDeliveryState.val();
                }

                orderForm.deliveryAddress = deliveryAddress;

                return orderForm;

                function getValue($input) {
                    var value = $input.val();
                    return !value && !$input.data('userChanged') ? null : value;
                }
            },
            suspendForUpdate: function () { },
            handleUpdatedOrder: function (checkoutOrder) {
                updateCheckoutUi(checkoutOrder);

                _state.updatingOrder = false;
                if (_state.sendOrderInitialized) {
                    sendOrder();
                }
            },
            handleConfirmOrder: function(paymentProviderInternalData) {
                confirmOrder(paymentProviderInternalData);
            }
        };
    }

    if (!w.checkoutProviders) {
        w.checkoutProviders = {};
    }

    w.checkoutProviders.paypal = checkout;

})(window, jQuery, _);